<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-3 col-xs-3 mb-10">
                                        <button v-if="currentCategory != null" class="btn btn-danger" @click="getCategoryItems(parentCategory)">{{$t('show_categories')}}</button>
                                    </div>
                                    <div class="col-sm-5 col-xs-6 mb-10" v-if="orderItems.length > 0">
                                        <form @submit.prevent="getCategoryItems(currentCategory)">
                                            <div class="input-group">
                                                <span class="input-group-addon glyphicon glyphicon-search" id="basic-addon1"></span>
                                                <input type="text" :placeholder="$t('search') + '...'" v-model="searchInput" class="form-control">
                                            </div>
                                        </form>
                                    </div>
                                    <div v-if="loggedInCustomer.addProducts" class="pull-right">
                                        <button class="btn btn-success" @click="showAddOrderItemModal()">{{$t('add_product')}}</button>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div v-for="category in filteredCategories" class="col-sm-3 card" @click="getCategoryItems(category.id)">
                                        <img class="card" v-if="category.imageLocation" :src="BACKEND_BASE_URL + '/images/' + category.imageLocation">
                                        <img class="card" v-if="!category.imageLocation" src="../assets/no-image.svg">
                                        <p>{{ getLocale() == 'nl' ? category.dutchTranslation : category.frenchTranslation}}</p>
                                    </div>
                                    <div v-if="filteredOrderItems.length > 0">
                                        <div class="panel">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <td></td>
                                                        <td>{{$t("article_number")}}</td>
                                                        <td>{{$t("article_name")}}</td>
                                                        <td v-if="loggedInCustomer.showPrices">{{$t("price")}}</td>
                                                        <td v-if="loggedInCustomer.id">{{$t("discount")}}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr style="height: 75px;" v-for="orderItem in filteredOrderItems">
                                                        <td v-if="orderItem.product.imageLocation" class="col-sm-1 align-middle">
                                                            <lightbox :caption="true"
                                                                      :images="[{src: BACKEND_BASE_URL + '/images/' + orderItem.product.imageLocation, caption: orderItem.product.dutchTitle}]">
                                                            </lightbox>
                                                        </td>
                                                        <td v-if="!orderItem.product.imageLocation" class="col-sm-1 align-middle">
                                                            <img src="../assets/no-image.svg" style="max-width: 100px;">
                                                        </td>
                                                        <td class="align-middle">{{orderItem.product.articleNumber}}</td>
                                                        <td class="align-middle"><strong>{{ getLocale() == 'nl' ? orderItem.product.dutchTitle : orderItem.product.frenchTitle}}</strong></td>
                                                        <td v-if="loggedInCustomer.showPrices" class="align-middle">€{{parseFloat(orderItem.product.price).toFixed(2)}} <span v-if="orderItem.product.customPrice"><i class="glyphicon glyphicon-info-sign" v-tooltip="'speciale prijs'"></i></span></td>
                                                        <td v-if="loggedInCustomer.id" class="align-middle">{{orderItem.product.discount || 0}}%</td>
                                                        <td class="align-middle"><i class="glyphicon glyphicon-info-sign" @click="showProduct(orderItem.product.id)"></i></td>
                                                        <td class="align-middle">
                                                            <input type="number" min="1" class="form-control align-middle" style="width: 75px; display: inline-block;" v-model="orderItem.product.amount" />
                                                            <button class="btn btn-xs btn-success align-middle" style="height: 32px;" @click="orderProduct(orderItem.product)">{{$t("order")}}</button>
                                                        </td>
                                                        <td class="align-middle"><i class="glyphicon glyphicon-trash" @click="deleteOrderItem(orderItem.productId)"></i></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import BtFooter from './BTFooter.vue'
    import AddCategoryModal from './modals/AddCategory.vue'
    import * as types from '../store/mutation-types'

    export default {
        name: 'MyOrders',
        components: {
            BtFooter,
            AddCategoryModal
        },
        created() {
            document.title = 'Brabant-Tools | Mijn orders'

            this.$store.dispatch('getAssignableCategories').then(() => {
                this.$store.dispatch('getOrderItemsForCustomer').then(() => {
                    if (this.orderItems && this.loggedInCustomer.id) {
                        this.$store.dispatch('getDiscounts').then(() => {
                            this.orderItems.forEach((orderItem) => {
                                this.discounts.forEach((discount) => {
                                    if (orderItem.product.categoryCode === discount.code && discount.active) {
                                        orderItem.product.discount = discount.discount
                                    }
                                })
                            })
                            this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                                this.orderItems.forEach((orderItem) => {
                                    this.customerSpecificPrices.forEach((customerSpecificPrice) => {
                                        if (orderItem.product.articleNumber === customerSpecificPrice.articleNumber) {
                                            orderItem.product.price = customerSpecificPrice.price
                                            orderItem.product.customPrice = true
                                            orderItem.product.discount = 0
                                        }
                                    })
                                })
                            })
                        })
                    }
                    this.getCategoryItems(null);
                })
            })
        },
        data() {
            return {
                BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL,
                searchInput: '',
                currentCategory: null,
                parentCategory: null,
            }
        },
        methods: {
            getLocale() {
                return this.$i18n.locale
            },
            showAddOrderItemModal() {
                this.$modal.show('add-orderItem-modal', { customerId: this.loggedInCustomer.id })
            },
            showProduct(productId) {
                this.$modal.show('show-product-modal', { productId: productId })
            },
            orderProduct(product) {
                if (isNaN(product.amount)) {
                    product.amount = 1
                }
                this.$store.commit(types.ADD_PRODUCT_TO_SHOPPING_CART, product)
                this.$store.dispatch('saveShoppingCart', this.loggedInCustomer.id)
                if (this.getLocale() === 'nl') {
                    this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Product is toegevoegd aan je winkelwagen!' })
                } else {
                    this.$notify({ group: 'success', type: 'success', title: 'Succès', text: 'Le produit a été ajouté à votre panier!' })
                }
            },
            deleteOrderItem(orderItemProductId) {
                this.$swal({
                    title: 'Let op!',
                    text: 'Je staat op het punt om een order item te verwijderen. Deze actie kan niet ongedaan worden!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Verwijderen',
                    cancelButtonText: 'Annuleren'
                }).then((result) => {
                    if (result) {
                        this.$store.commit(types.REMOVE_ORDERITEM_FROM_ORDERITEMS_FILTERED, orderItemProductId)
                        this.$store.dispatch('deleteOrderItem', orderItemProductId)
                    }
                })
            },
            getChildren(categoryId) {
                const allCategories = this.assignableCategories;
                var fillArray = function (parentId) {
                    let childCategories = allCategories.filter(c => c.parentId === parentId);
                    childCategories.forEach(x => {
                        children.push(x);
                        return fillArray(x.id);
                    });
                }
                const children = [];
                fillArray(categoryId)
                return children;
            },
            getCategoryItems(categoryId) {
                this.currentCategory = categoryId;
                this.parentCategory = null;
                let cat = this.assignableCategories.find(c => { return c.id === categoryId });
                if (cat != null) {
                    let parent = this.assignableCategories.find(c => { return c.id === cat.parentId });
                    this.parentCategory = parent.parentId != null ? cat.parentId : null;
                }
                let allCategories = [];
                if (categoryId == null) {
                    allCategories = this.assignableCategories;
                }
                else {
                    allCategories = this.getChildren(categoryId);
                }

                const categories = [];
                const searchOrderItems = this.orderItems.filter(orderItem => {
                    return orderItem.product.dutchTitle.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1 ||
                        orderItem.product.articleNumber.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1 ||
                        orderItem.product.frenchTitle.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1
                });
                searchOrderItems.forEach((orderItem) => {
                    let category = allCategories.find(c => { return c.id === orderItem.product.categoryId })
                    if (category) {
                        let childCategory = category;
                        while (category.parentId != categoryId) {
                            childCategory = category;
                            category = this.assignableCategories.find(c => { return c.id === category.parentId })
                        }
                        if (!categories.find(c => { return c.id === childCategory.id })) {
                            categories.push(childCategory);
                        }
                    }
                });
                this.$store.commit(types.SET_CATEGORIES, categories)
                const filtered = searchOrderItems.filter(orderItem => orderItem.product.categoryId === categoryId)
                this.$store.commit(types.SET_ORDER_ITEMS_FILTERED, filtered)
            }
        },
        computed: {
            ...mapGetters({
                assignableCategories: 'assignableCategories',
                categoriesByParent: 'categoriesByParent',
                orderItems: 'orderItems',
                loggedInCustomer: 'loggedInCustomer',
                discounts: 'discounts',
                customerSpecificPrices: 'customerSpecificPrices',
                categories: 'categories',
                orderItemsFiltered: 'orderItemsFiltered',
            }),
            filteredOrderItems() {
                return this.orderItemsFiltered.sort((a, b) => a.product.articleNumber.localeCompare(b.product.articleNumber))
            },
            filteredCategories() {
                return this.categories.sort((a, b) => a.dutchTranslation.localeCompare(b.dutchTranslation))
            },
        }
    }
</script>

<style scoped>
    .card {
        padding: 0;
        margin-right: 40px;
        margin-bottom: 10px;
        cursor: pointer;
        height: 150px;
        width: 150px;
        background-color: white;
    }

        .card p {
            text-align: center;
            font-weight: 600;
            margin-bottom: 75px;
        }

        .card img {
            width: 100%;
            margin-bottom: 5px !important;
        }

    div .card {
        margin-bottom: 100px;
    }

    .breadcrumb {
        background: none;
    }

    a {
        cursor: pointer;
    }

    ol li.breadcrumb-link:last-child a {
        cursor: default;
        color: #2c3e50;
        text-decoration: none;
    }

    .mb-10 {
        margin-bottom: 10px;
    }

    .glyphicon {
        top: 0;
        cursor: pointer;
    }
</style>
